import { STATUS, PRIORITY } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className }) => {
  const s = STATUS[status] || { label: status, cls: "bg-slate-500/10 text-slate-300 border-slate-500/20" };
  const Icon = s.icon;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn("inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border px-2 py-0.5 font-mono text-[11px] font-medium uppercase tracking-wide", s.cls, className)}
    >
      {Icon && <Icon className="h-3 w-3" strokeWidth={2.2} />}
      {s.label}
    </span>
  );
};

export const PriorityTag = ({ priority }) => {
  const p = PRIORITY[priority] || PRIORITY.media;
  return (
    <span className={cn("inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-wide", p.cls)}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {p.label}
    </span>
  );
};

export const BuDot = ({ meta, code, name }) => {
  const bu = meta?.business_units?.find((b) => b.code === code);
  return (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <span className="h-2 w-2 rounded-sm" style={{ background: bu?.color || "#64748b" }} />
      {name || bu?.name || code}
    </span>
  );
};
